import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="index-constituents"
export default class extends Controller {
  static targets = [
    "currentFilter", 
    "availableFilter", 
    "currentList", 
    "availableList", 
    "removeCounter", 
    "addCounter",
    "selectAllCurrentContainer",
    "selectAllAvailableContainer"
  ]
  
  connect() {
    // Ensures the counters are updated on page load
    this.updateRemoveCount()
    this.updateAddCount()
  }
  
  filterCurrentConstituents() {
    const query = this.currentFilterTarget.value.toLowerCase()
    this.filterItems(this.currentListTarget, query)
  }
  
  filterAvailableStocks() {
    const query = this.availableFilterTarget.value.toLowerCase()
    this.filterItems(this.availableListTarget, query)
  }
  
  filterItems(container, query) {
    const items = container.querySelectorAll('.form-check')
    
    items.forEach(item => {
      const text = item.textContent.toLowerCase()
      const ticker = item.getAttribute('data-ticker')?.toLowerCase() || ''
      
      if (text.includes(query) || ticker.includes(query) || query === '') {
        item.style.display = ''
      } else {
        item.style.display = 'none'
      }
    })
    
    // Update "select all" checkbox visibility based on filtered items
    this.updateSelectAllVisibility()
  }
  
  clearCurrentFilter() {
    this.currentFilterTarget.value = ''
    this.filterCurrentConstituents()
  }
  
  clearAvailableFilter() {
    this.availableFilterTarget.value = ''
    this.filterAvailableStocks()
  }
  
  updateRemoveCount() {
    const selected = this.currentListTarget.querySelectorAll('.current-constituent:checked')
    const counter = this.removeCounterTarget
    const badge = counter.querySelector('.badge.count')
    
    // Always update the count
    badge.textContent = selected.length

    // Update styling based on count
    if (selected.length > 0) {
      counter.classList.remove('alert-light')
      counter.classList.add('alert-warning')
      badge.classList.add('bg-danger')
    } else {
      counter.classList.remove('alert-warning')
      counter.classList.add('alert-light')
    }
  }
  
  updateAddCount() {
    const selected = this.availableListTarget.querySelectorAll('.available-stock:checked')
    const counter = this.addCounterTarget
    const badge = counter.querySelector('.badge.count')
    
    // Always update the count
    badge.textContent = selected.length

    // Update styling based on count
    if (selected.length > 0) {
      counter.classList.remove('alert-light')
      counter.classList.add('alert-success')
      badge.classList.add('bg-success')
    } else {
      counter.classList.remove('alert-success')
      counter.classList.add('alert-light')
    }
  }
  
  toggleSelectAllCurrent(event) {
    const checkboxes = this.currentListTarget.querySelectorAll('.current-constituent:not([style*="display: none"])')
    checkboxes.forEach(checkbox => {
      checkbox.checked = event.target.checked
    })
    this.updateRemoveCount()
  }
  
  toggleSelectAllAvailable(event) {
    const checkboxes = this.availableListTarget.querySelectorAll('.available-stock:not([style*="display: none"])')
    checkboxes.forEach(checkbox => {
      checkbox.checked = event.target.checked
    })
    this.updateAddCount()
  }
  
  updateSelectAllVisibility() {
    // Update "select all" visibility based on filtered items
    const visibleCurrentItems = this.currentListTarget.querySelectorAll('.form-check:not([style*="display: none"])')
    this.selectAllCurrentContainerTarget.style.display = visibleCurrentItems.length > 0 ? '' : 'none'
    
    const visibleAvailableItems = this.availableListTarget.querySelectorAll('.form-check:not([style*="display: none"])')
    this.selectAllAvailableContainerTarget.style.display = visibleAvailableItems.length > 0 ? '' : 'none'
  }
}